var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhaseStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_10033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "url(#paint0_linear_398_10033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7428 8.80911C17.667 8.57579 17.4653 8.40572 17.2226 8.37044L13.3223 7.80368L11.578 4.26942C11.4694 4.04942 11.2453 3.91016 11 3.91016C10.7547 3.91016 10.5306 4.04942 10.422 4.26946L8.67776 7.80373L4.77744 8.37048C4.53467 8.40576 4.33293 8.57583 4.25714 8.80915C4.18134 9.04247 4.24459 9.29861 4.42025 9.46984L7.24256 12.2209L6.57629 16.1054C6.53482 16.3472 6.63421 16.5916 6.83268 16.7358C7.0312 16.88 7.2943 16.8991 7.51146 16.7849L11 14.9508L14.4886 16.7849C14.7074 16.8999 14.9703 16.8789 15.1673 16.7358C15.3658 16.5916 15.4652 16.3472 15.4238 16.1054L14.7575 12.2209L17.5798 9.46984C17.7554 9.29857 17.8186 9.04243 17.7428 8.80911V8.80911Z",
    fill: "url(#paint1_linear_398_10033)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_10033",
    x1: 11,
    y1: 22,
    x2: 11,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_398_10033",
    x1: 11,
    y1: 16.8589,
    x2: 11,
    y2: 3.91016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_10033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseStar);
export default __webpack_public_path__ + "static/media/PhaseStar.cef720b5bd076a0d684c5be6665ab0a9.svg";
export { ForwardRef as ReactComponent };